import Navbar from '../../components/Navbar/Navbar';
import Footer from '../../components/Footer/Footer';
import '../../styles/Pages.css';

function ICTFacilities() {
    const facilities = [
        { icon: '🖥️', title: 'Computer Lab', desc: 'Fully equipped computer lab with multimedia and high-speed internet connectivity for students and research.' },
        { icon: '📡', title: 'Internet Connectivity', desc: 'Wi-Fi enabled campus ensuring uninterrupted internet access for students and faculty.' },
        { icon: '📽️', title: 'Smart Classrooms', desc: 'Classrooms equipped with projectors and audio-visual tools for modern teaching methods.' },
        { icon: '🎙️', title: 'Seminar Hall AV', desc: 'Audio-visual equipment for seminars, conferences, and workshops.' },
        { icon: '📂', title: 'Digital Library', desc: 'Access to digital resources, e-journals, and INFLIBNET N-LIST for students and faculty.' },
        { icon: '🔒', title: 'CCTV Surveillance', desc: 'Campus security maintained through CCTV cameras at key locations.' },
    ];
    return (
        <div className="page-wrapper">
            <Navbar />
            <div className="page-hero">
                <p className="page-breadcrumb"><a href="/">Home</a> › ICT Facilities</p>
                <h1>ICT Facilities</h1>
                <p>Modern Information and Communication Technology infrastructure for teaching and learning.</p>
            </div>
            <div className="page-content">
                <div className="cards-grid">
                    {facilities.map(f => (
                        <div className="grid-card" key={f.title}>
                            <div style={{ fontSize: '1.9rem', marginBottom: '0.5rem' }}>{f.icon}</div>
                            <h3>{f.title}</h3>
                            <p>{f.desc}</p>
                        </div>
                    ))}
                </div>
                <div className="info-card" style={{ marginTop: '1.5rem' }}>
                    <h2>PowerPoint Bank</h2>
                    <p>The college maintains a repository of teaching presentations created by faculty. Students can access these from the <a href="/powerpoint-bank" style={{ color: '#2d6a4f' }}>PowerPoint Bank</a> page after login.</p>
                </div>
                <div className="info-card">
                    <h2>Teacher ICT Usage</h2>
                    <p>Faculty are encouraged to use ICT tools including e-content, video lectures, and online assessment platforms. The <a href="/teacher-list" style={{ color: '#2d6a4f' }}>Teacher List</a> with ICT competency details is available for reference.</p>
                </div>
            </div>
            <Footer />
        </div>
    );
}
export default ICTFacilities;
